<!-- Awair Tab -->
<awair-tab-group [selectedTabIndex]="selectedTabIndex"
                 (selectTabIndex)="onSelectTabIndex($event)">

  <awair-tab [title]="'Floor List'">
    <awair-floor-list [floors]="floors"
                      [selectedFloorId]="selectedFloorId"
                      (selectFloor)="onSelectFloor($event)">
    </awair-floor-list>
  </awair-tab>
  <awair-tab [title]="'Device List'">
    <awair-floor-plan-device-list [devicesWithPolledAirData]="devicesWithPolledAirData"
                                  (selectDevice)="onSelectDevice($event)">
    </awair-floor-plan-device-list>
  </awair-tab>
</awair-tab-group>
<!-- /.Awair Tab -->
